import { render, staticRenderFns } from "./OrganizationTemplate.vue?vue&type=template&id=85d5aea2"
import script from "./OrganizationTemplate.vue?vue&type=script&lang=js"
export * from "./OrganizationTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports